import React from 'react';
import { NavLink } from 'react-router-dom';
import { Container, Title } from '../styled/styled';

import telegram from '../../image/contact-icon/telegram.png';
import github from '../../image/contact-icon/github.png';
import twitter from '../../image/contact-icon/twitter.png';
import upwork from '../../image/contact-icon/upwork.png';
import email from '../../image/contact-icon/email.png';
import ellipse from '../../image/Ellipse.svg';
import styled from 'styled-components';

const imageMok = [
  {
    id: 1,
    image: telegram,
    link: 'https://t.me/itzeyz',
  },
  {
    id: 2,
    image: github,
    link: 'https://github.com/ITZeyz',
  },
  {
    id: 3,
    image: twitter,
    link: 'https://twitter/itzeyz',
  },
  {
    id: 4,
    image: upwork,
    link: 'https://upwork/itzeyz',
  },
  {
    id: 5,
    image: email,
    link: 'itzeyzdevelop@gmail.com',
  },
];

const ContactStyled = styled.div`
  margin-top: -90px;
  height: 100vh;
  display: flex;
  align-items: center;
  position: relative;
  @media (max-width: 992px) {
    &::after {
      display: none;
    }
  }
  @media (max-width: 440px) {
    a {
      font-style: normal;
      font-weight: 400;
      font-size: 17px;
      line-height: 20px;
      text-align: center;
      color: #000000;
    }
    .item img {
      width: 20% !important;
    }
  }
  @media (max-height: 660px) {
    margin-top: -40px;
  }
  @media (max-height: 460px) {
    margin-top: -50px;
  }
`;

const ContactContent = styled.div`
  max-width: 1030px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  margin-top: 50px;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  a {
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    margin-left: 10px;
    color: #000000;
  }
  &::after {
    content: '';
    position: absolute;
    right: -50px;
    bottom: 0px;
    background: url(${ellipse}) no-repeat center;
    width: 565px;
    height: 448px;
    z-index: -1;
  }
  @media (max-width: 992px) {
    &::after {
      display: none;
    }
  }
  @media (max-width: 640px) {
    a {
      margin-left: 0px;
    }
  }
  @media (max-height: 560px) {
    margin-top: 20px;
    a {
      font-style: normal;
      font-weight: 400;
      font-size: 17px;
      line-height: 20px;
    }
  }
`;

const ContactItem = styled.a`
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  img {
    margin-right: 10px;
    width: 100% !important;
  }
  @media (max-width: 640px){
    margin-bottom: 20px;
    img {
      margin-right: 0;
      width: 40px !important;
      margin-bottom: 10px;
    }
    &:nth-child(4) img{
      width: 40% !important;
    }
    flex-direction column;
  }
  @media (max-height: 560px){
    margin-bottom: 10px;
    img {
      width: 30px !important;
    }
    &:nth-child(4) img{
      width: 30% !important;
    }
  }
`;

export const Contact = () => {
  return (
    <ContactStyled id="contact">
      <Container>
        <Title>YOU CAN REACH US</Title>
        <ContactContent>
          {imageMok.map((item) => (
            <ContactItem target="_blank" href={item.link} key={item.id}>
              <img src={item.image} alt="" />
              <p>{item.link}</p>
            </ContactItem>
          ))}
        </ContactContent>
      </Container>
    </ContactStyled>
  );
};
